<script module lang="ts">
	export enum DividerType {
		THIN,
		THICK
	}
</script>

<script lang="ts">
	interface Props {
		dividerType?: DividerType
	}

	let { dividerType = DividerType.THIN }: Props = $props()
</script>

<div
	class="divider"
	class:divider--thick={dividerType === DividerType.THICK}
	class:h-px={dividerType === DividerType.THIN}
/>

<style>
	.divider {
		@apply w-full bg-[#003a66]/10 my-6;
	}

	.divider--thick {
		height: 2px;
	}

	.h-px {
		height: 1px;
	}
</style>
